export const kebabToCamel = (s: string) =>
  s.replace(/-./g, x => x[1].toUpperCase())

export const firstLetterLowercase = (s: string) =>
  s.charAt(0).toLowerCase() + s.slice(1)

export const transformBankAccountNumber = (s: string) => {
  const trimmed = s.replace(/\s/g, '')
  return (
    (trimmed.length > 4 ? trimmed.match(/.{1,4}/g)?.join(' ') : trimmed) || s
  )
}

export const getPathname = (pathname: string, offset = -1) => {
  const parts = pathname.split('/')
  return parts.slice(0, offset).join('/')
}

export const getInitials = (name: string) => {
  const parts = name.split(' ')

  if (!parts.length) return ''

  if (parts.length < 2) return parts[0][0]

  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toLocaleUpperCase()
}
